import { useState } from "react";
import { Tabs } from "~/shared";
import ProfessionalDidacticMethodicalHint from "./professional_didacticMethodicalHint";
import Curricula from "./curricula";
import ProfessionalSideBarArticle from "./professional_tab_sidebar";
// import SequencesArticle from "./sequences_article";

import type { ArticleData } from "~/types";
import type { currentTabProp } from "~/shared";

export const ProfessionalArticleTabs = ({
  didacticMethodicalHint,
  curriculums,
  mediaKindsAsString,
  link,
  createdAt,
  licenses,
  specials,
  subjects,
  tagList,
  reversedSequences,
  relatedMedia = [],
}: ArticleData) => {
  const [current, setCurrent] = useState<currentTabProp>({
    status: "unassigned",
    id: 1,
  });
  const tabs = [
    {
      name: "Religionsunterricht",
      status: "default",
      id: 1,
    },
  ];

  const renderCurrentTab = () => {
    switch (current.id) {
      case 0:
        return null;
      case 2:
        return null;

      default:
        return (
          <section aria-labelledby="products-heading" className="pt-4 pb-24">
            <h2 id="products-heading" className="sr-only">
              Products
            </h2>

            <div className="grid grid-cols-1 gap-8 lg:grid-cols-4 2xl:gap-1">
              {/* left tabs content  grid */}
              <div className="lg:col-start-1 lg:col-end-3">
                <ProfessionalDidacticMethodicalHint
                  didacticMethodicalHint={didacticMethodicalHint}
                  // inclusionHint={inclusionHint}
                />
                {/* {sequences.length ? (
                  <SequencesArticle sequences={sequences} />
                ) : null} */}
                <Curricula curriculums={curriculums} />
              </div>

              {/* Side NAv */}
              <div className="h-full lg:col-start-3 lg:col-end-5">
                <ProfessionalSideBarArticle
                  relatedMedia={relatedMedia}
                  reversedSequences={reversedSequences}
                  createdAt={createdAt}
                  licenses={licenses}
                  mediaKindsAsString={mediaKindsAsString}
                  link={link}
                  specials={specials}
                  subjects={subjects}
                  tagList={tagList}
                />
              </div>
            </div>
          </section>
        );
    }
  };

  return (
    <div className="pt-16">
      <Tabs
        tabs={tabs}
        onSelect={setCurrent}
        current={current.id}
        counter={0}
      />
      {renderCurrentTab()}
    </div>
  );
};
